import { SummaryViews } from '@mark43/dex-api';
import { VStack } from '@cad-arc';
import { DexPersonResultSummary } from './dex-person-result-summary';
import { DexVehicleResultSummary } from './dex-vehicle-result-summary';

export function ResultSummary({ summaryViews }: { summaryViews: SummaryViews }) {
    const { vehicleSummaryView, registeredOwnerSummaryView } = summaryViews;
    return (
        <VStack align="left" w="100%">
            {registeredOwnerSummaryView ? (
                <DexPersonResultSummary person={registeredOwnerSummaryView} />
            ) : undefined}
            {vehicleSummaryView ? (
                <DexVehicleResultSummary vehicle={vehicleSummaryView} />
            ) : undefined}
        </VStack>
    );
}
